import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const SocialWellbeingIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path d="M13,4.39A2,2,0,1,0,15.5,3,2,2,0,0,0,13,4.39Z" fillRule="evenodd" clipRule="evenodd" />
      <path
        d="M16.14,8.81,13.25,8A5,5,0,0,1,9.63,2.66a1,1,0,1,0-2-.23,7,7,0,0,0,3.21,6.68l-2.52,9a1,1,0,1,0,1.93.54l.55-1.92,1.92.54L11.4,22a1,1,0,1,0,1.93.54l3.13-11.14a5,5,0,0,1,1.81,4.41,1,1,0,0,0,2,.22A7.17,7.17,0,0,0,16.14,8.81Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M8.17,14.71,9.65,9.46a3.52,3.52,0,0,1-1-.76C8.49,8.52,7.05,9,6,9.57c-.84.43-2.27,1-3.19-.39-.19-.24-.36,0-.35.17,0,0-.07,1.33.42,1.73s.9.4,1.13,1.2S4.55,13.86,5.35,14s1.57,0,2.05.73a5.91,5.91,0,0,1,.54.89Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </IconBase>
  );
};

export default SocialWellbeingIcon;
